// extracted by mini-css-extract-plugin
export var container = "_fv-0";
export var dotAnimation = "_fv-2";
export var dotsLoading = "_fv-1";